module.exports = __webpack_public_path__ + "static/media/simonSound2.c3c86e71.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simonSound2.mp3
// module id = 203
// module chunks = 0